import React from 'react';
import styled from 'styled-components';

const LogoWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const LogoShape = styled.img`
  width: 60px;
  height: 60px;
  margin-right: 0px;
`;

const LogoText = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 10px;
  margin-left: -22px;
`;

const ElectroText = styled.span`
  font-size: 1.5rem;
  line-height: 1.2;
  color: ${({ theme }) => theme.colors.light};
`;

const CableText = styled.span`
  font-size: 1.5rem;
  line-height: 1.2;
  color: ${({ theme }) => theme.colors.primary};
`;

const Logo: React.FC = () => {
  return (
    <LogoWrapper>
      <LogoShape src="/images/logo.svg" className="logo-shape" alt="Logo" />
      <LogoText>
        <ElectroText>ELECTRO</ElectroText>
        <CableText>CABLE</CableText>
      </LogoText>
    </LogoWrapper>
  );
};

export default Logo; 